import { render } from "./DashChartPayments.vue?vue&type=template&id=2284d4ac&scoped=true&ts=true"
import script from "./DashChartPayments.vue?vue&type=script&lang=ts"
export * from "./DashChartPayments.vue?vue&type=script&lang=ts"

import "./DashChartPayments.vue?vue&type=style&index=0&id=2284d4ac&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2284d4ac"]])

export default __exports__